import { useIntl } from 'react-intl';

export function Tr() {
  const intl = useIntl();

  return (id?: string | null) => {
    if (!id) return ""; // prevent React-Intl crash
    return intl.formatMessage({ id, defaultMessage: id });
  };
}
